// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreatmentPlan{  
    /*background-color: #f9f9f9;*/
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 46px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
}

.TreatmentPlan_header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}

.TreatmentPlan_title{
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;

    color: #8E9ABB;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/treatmentPlan/TreatmentPlan.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB","sourcesContent":[".TreatmentPlan{  \n    /*background-color: #f9f9f9;*/\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 46px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n}\n\n.TreatmentPlan_header{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.TreatmentPlan_title{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n\n    color: #8E9ABB;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
